import {PropsWithChildren} from "react";

interface Props {
    className?: string;
}

export const Title = ({children, className}: PropsWithChildren<Props>) => <p
    className={className}
    style={{
        fontSize: '3rem',
        fontWeight: '500',
    }}>
    {children}
</p>;